import { useEffect, useState } from 'react';
import api from '../lib/api';
import { formatAddress } from '../lib/blockchain';

const getWalletAddress = (props) =>
  props?.account ||
  props?.wallet?.account ||
  props?.wallet?.address ||
  props?.walletState?.account ||
  props?.walletState?.address ||
  props?.metaMask?.account ||
  props?.metaMask?.address ||
  '';

const formatValue = (value, fallback = '—') => {
  if (value === undefined || value === null || value === '') return fallback;
  return `${value}`;
};

export default function Dashboard(props) {
  const account = getWalletAddress(props);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [latestBlock, setLatestBlock] = useState(null);
  const [price, setPrice] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');

      try {
        const [statusResult, blockResult, priceResult] = await Promise.allSettled([
          api.chain.status(),
          api.chain.latestBlock(),
          api.oracle.price(),
        ]);

        if (statusResult.status === 'fulfilled') setStatus(statusResult.value);
        if (blockResult.status === 'fulfilled') setLatestBlock(blockResult.value);
        if (priceResult.status === 'fulfilled') {
          setPrice(
            priceResult.value?.price ??
              priceResult.value?.oracle_price ??
              priceResult.value?.value ??
              null
          );
        }
      } catch (err) {
        setError(err?.response?.data?.error || err?.message || 'Unable to load dashboard data.');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <div className="space-y-6">
      <section className="glass p-6">
        <p className="text-sm uppercase tracking-wide text-slate-400">Dashboard</p>
        <h1 className="mt-2 text-3xl font-semibold text-white">HudLife network overview</h1>
        <p className="mt-2 text-slate-300">
          Monitor live chain status, market reference data and your currently connected wallet.
        </p>
      </section>

      {error ? (
        <section className="glass border border-rose-500/30 p-4 text-rose-200">{error}</section>
      ) : null}

      <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <article className="glass p-5">
          <p className="text-sm text-slate-400">Chain status</p>
          <h2 className="mt-2 text-2xl font-semibold text-white">
            {loading ? 'Loading…' : formatValue(status?.status || status?.state, 'Unknown')}
          </h2>
        </article>

        <article className="glass p-5">
          <p className="text-sm text-slate-400">Latest block</p>
          <h2 className="mt-2 text-2xl font-semibold text-white">
            {loading
              ? 'Loading…'
              : formatValue(latestBlock?.height || latestBlock?.number || latestBlock?.block_height, '—')}
          </h2>
        </article>

        <article className="glass p-5">
          <p className="text-sm text-slate-400">Oracle price</p>
          <h2 className="mt-2 text-2xl font-semibold text-white">{formatValue(price, 'Unavailable')}</h2>
        </article>

        <article className="glass p-5">
          <p className="text-sm text-slate-400">Connected wallet</p>
          <h2 className="mt-2 text-2xl font-semibold text-white">
            {account ? formatAddress(account) : 'Not connected'}
          </h2>
        </article>
      </section>
    </div>
  );
}
